const AlertCircle = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="19.5"
        y="19.5"
        width="19"
        height="19"
        rx="9.5"
        transform="rotate(-180 19.5 19.5)"
        fill="var(--left-bubble-bg)"
      />
      <rect
        x="19.5"
        y="19.5"
        width="19"
        height="19"
        rx="9.5"
        transform="rotate(-180 19.5 19.5)"
        stroke="var(--left-bubble-top-border)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.41083 6.91085C9.56711 6.75462 9.77903 6.66686 10 6.66686C10.221 6.66686 10.4329 6.75462 10.5892 6.91085L15.3033 11.625C15.3829 11.7019 15.4464 11.7938 15.4901 11.8955C15.5338 11.9972 15.5567 12.1065 15.5577 12.2172C15.5587 12.3278 15.5376 12.4376 15.4957 12.54C15.4538 12.6424 15.3919 12.7354 15.3137 12.8137C15.2354 12.8919 15.1424 12.9538 15.04 12.9957C14.9375 13.0376 14.8278 13.0587 14.7172 13.0577C14.6065 13.0568 14.4972 13.0338 14.3955 12.9901C14.2938 12.9464 14.2019 12.8829 14.125 12.8033L10 8.67835L5.875 12.8033C5.71783 12.9551 5.50733 13.0391 5.28883 13.0372C5.07033 13.0353 4.86132 12.9477 4.70682 12.7932C4.55231 12.6387 4.46467 12.4297 4.46277 12.2112C4.46087 11.9927 4.54487 11.7822 4.69666 11.625L9.41083 6.91085Z"
        fill="var(--left-bubble-arrow)  "
      />
    </svg>
  );
};

export default AlertCircle;
